import { useRouteError, Navigate } from "react-router-dom";
import Error from "../components/Error";

function ErrorElement() {
  const error = useRouteError();

  // Detect chunk load failures (new deployment) and auto-reload
  const isChunkError = error?.message?.includes('Failed to fetch dynamically imported module') ||
                       error?.message?.includes('Loading chunk') ||
                       error?.message?.includes('importScripts');

  if (isChunkError) {
    // Hard reload to get fresh assets from new deployment
    // Avoid infinite loops: reload once, then show manual fallback if it still fails
    const reloadKey = '_chunk_reload';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      const url = new URL(window.location.href);
      url.searchParams.set('_cb', Date.now().toString());
      window.location.replace(url.toString());
    } else {
      sessionStorage.removeItem(reloadKey);
    }
    return null; // Prevent further rendering during reload
  }

  if (process.env.NODE_ENV === 'development') {
    // API not available in development
  }
  if (error?.response?.status === 401) return <Navigate to="/login" />;
  if (error?.response?.status === 403) return <Navigate to="/login" />;
  if (error?.response?.status === 404) return <Navigate to="/NotFound" />;
  return <Error />;
}

export default ErrorElement;
